import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

// Define la interfaz para los datos de un blog, basándose en el modelo de C#
export interface Blog {
  id: number;
  date: string; // O Date si prefieres manejarlo como objeto de fecha
  title: string;
  description: string;
  imageName: string;
  seo: string;
  status: number;
  language: string;
}

// Define la interfaz para la respuesta completa del API
export interface BlogsResponse {
  status: number;
  message: string;
  data: Blog[];
}

export const GetBlogs = async (): Promise<Blog[]> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/get-blog`;

    // Asumimos que tu token está en localStorage.getItem('token')
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token de autorización no disponible');
    }

    const response: AxiosResponse<BlogsResponse> = await axios.post(
      endpoint,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    console.log(response.data.data, "Blogs obtenidos");
    return response.data.data;

  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Manejar el caso de error con una respuesta del API
      throw new Error(error.response.data.message);
    }
    // Manejar otros tipos de errores (ej. de red)
    console.error('Error al obtener blogs:', error);
    throw error;
  }
};